<template>
  <div class="malden-we-are-logo container mx-auto text-center mb-8 pt-2">
    <img src="/img/we-are-mc.svg" class="w-3/4">
    <h2 class="text-white text-1xl font-bold mt-4">#WeAreMC</h2>
  </div>
</template>

<script>
export default {
  name: "maldenWeAreLogo"
};
</script>
